module.exports = __webpack_public_path__ + "da8a1ee38b4a9b6249e358b48d0e0fb9.svg";